import { Select } from "antd";
import { useState } from "react";

interface Option {
  value: string;
  label: string;
}

const removeDiacritics = (str: string): string => {
  return str?.normalize("NFD").replace(/[\u0300-\u036f]/g, "") ?? "";
};

export const filterOptionDiacritics: any = (input: string, option: Option) => {
  const normalizedInput = removeDiacritics(input.toLowerCase());
  const normalizedOptionLabel = removeDiacritics(option.label?.toLowerCase());
  return normalizedOptionLabel.includes(normalizedInput);
};

const SingleMultiselect: React.FC<any> = (props) => {
  const { onChange, mode = "multiple" } = props;
  const [visible, setVisible] = useState<boolean>(false);
  return (
    <Select
      {...props}
      mode={mode}
      open={visible}
      onDropdownVisibleChange={(open) => setVisible(open)}
      onChange={(value: any) => {
        if (value?.length > 1) {
          onChange(value.pop());
        } else onChange(value);
        setVisible(false);
      }}
    />
  );
};
export default SingleMultiselect;
